import React from "react";
import i18n from "i18next";
import k from "src/i18n/keys";

import { Checkbox } from "src/components/Unifize";
import { CellItem } from "../styles";
import type { FieldId } from "src/types";
import type { AiFlatChecklistSuggestionValue } from "src/ts-types";

type Props = {
  fieldId: FieldId;
  isDisabled?: boolean;
  value: AiFlatChecklistSuggestionValue;
  toggleSuggestion?: (
    fieldId: FieldId,
    fieldSuggestionIndex: number,
    embeddedSuggestionIndex?: number,
  ) => void;
  isSuggestionSelected: (
    fieldId: FieldId,
    fieldSuggestionIndex: number,
    embeddedSuggestionIndex?: number,
  ) => boolean;
};

const Picklist = ({
  fieldId,
  isDisabled,
  value,
  toggleSuggestion,
  isSuggestionSelected,
}: Props) => {
  if (!value || !toggleSuggestion) return null;

  const isMultiValue = Array.isArray(value);
  const isSingleValue = !Array.isArray(value) || value.length === 1;
  return (
    <>
      {(Array.isArray(value) ? value : [value]).map((item, index) =>
        isSingleValue ? (
          <span>{item}</span>
        ) : isMultiValue ? (
          <CellItem key={index}>
            {!isDisabled && (
              <Checkbox
                checked={isSuggestionSelected(fieldId, index)}
                onChange={() => {
                  toggleSuggestion(fieldId, index);
                }}
                isDisabled={isDisabled ?? false}
              />
            )}
            <span>{item}</span>
          </CellItem>
        ) : (
          <span>{i18n.t(k.INVALID_VALUE)}</span>
        ),
      )}
    </>
  );
};

export default Picklist;
